import React, { createContext, useContext } from 'react';
import { ISize } from 'app/components/layout/useMeasure';

const ViewportContext = createContext<ISize>({ width: 0, height: 0 });

export const GetViewport = ViewportContext.Consumer;
export const useViewport = () => useContext(ViewportContext);

export const SetViewportSize: React.FC<{ size: ISize }> = ({ size, children }) => (
  <ViewportContext.Provider value={size}>
    {children}
  </ViewportContext.Provider>
);
